import { render, staticRenderFns } from "./inventoryDetailsModal.vue?vue&type=template&id=0d0106b2&scoped=true"
import script from "./inventoryDetailsModal.vue?vue&type=script&lang=js"
export * from "./inventoryDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0106b2",
  null
  
)

export default component.exports